import { graphql } from "gql";

const TAG_LIST_QUERY = graphql(`
  query TagList {
    tagList {
      ...Tag
    }
    tagCategoryList {
      ...TagCategory
    }
  }
`);

export default TAG_LIST_QUERY;
